import Grid from '../../components/Grid';
import EstadisticaService from '../../services/estadisticas_service.js';
import SedeService from '../../services/sede_service.js';
import AlertService from '../../services/alert_service.js';
import GeneralService from '../../services/general_service.js';
import ChartCard from '../../components/Cards/ChartCard.vue';
import StatsCard from '../../components/Cards/StatsCard.vue';
import DatosParametricosService from '../../services/datos_parametricos_service.js';

const alertService = new AlertService();
const generalService = new GeneralService();
const estadisticaService = new EstadisticaService();
const sedeService = new SedeService();
const datosParametricosService = new DatosParametricosService();


let _this;
let search =JSON.stringify({fechaDesde: '2023-01-01', fechaHasta: '', sede: '', fechaTipoDesde: '2023-01-01', fechaTipoHasta: '', sedeTipo: '', 
							idEspecialidadInternacion: '', idSubEspecialidad: '', 
							fechaNivelDesde: '2023-01-01', fechaNivelHasta: '', sedeNivel: '', idEspecialidadInternacionNivel: '', idSubEspecialidadNivel: '', 
							fechaStaffDesde: '2023-01-01', fechaStaffHasta: '', sedeStaff: '', idEspecialidadInternacionStaff: '', idSubEspecialidadStaff: '',
							fechaCirujanoDesde: '2023-01-01', fechaCirujanoHasta: '', sedeCirujano: '', idEspecialidadInternacionCirujano: '', idSubEspecialidadCirujano: '', 
							fechaObraSDesde: '2023-01-01', fechaObraSHasta: '', sedeObraS: '', idEspecialidadObraS: '', idSubEspecialidadObraS: '', 
							fechaEspecialidadDesde: '2023-01-01', fechaEspecialidadHasta: '', sedeEspecialidad: '', idEspecialidadInternacionEspecialidad: '', idSubEspecialidadEspecialidad: '', 
							fechaSubEspecialidadDesde: '2023-01-01', fechaSubEspecialidadHasta: '', sedeSubEspecialidad: '', idEspecialidadInternacionSubEspecialidad: '', idSubEspecialidadSubEspecialidad: ''});

export default {
	name: 'EstCirugia',
	components: { Grid, ChartCard, StatsCard },
	data: function() {
		return {
			titulo: 'ESTADISTICAS DE CIRUGIA',
			searchQuery: '',
			search: JSON.parse(search),
			chartId: "1",
			tituloGrafico: '',
			generalService: generalService,
			sedes: [],
			submited: false,
			cantidadCirugias: '-',
			internacionesPorTipo: [],
			cantidadInternaciones:  '-',
			cantidadInternacionesAmbulatorias: '-',
			cirugiasPorNiveles: [],
			especialidades: [],
			subespecialidades: [],
			totalProcedimientos: '-',
			internacionesPorStaff: [],
			cirugiasPorCirujano: [],
			cirugiasPorObraSocial: [],
			internacionesPorEspecialidad: [],
			cirugiasPorSubEspecialidad: [],
			internacionesAmbulatorias: [],
			cirugiasPorVia: [],
			pieChart: {
				data: {
					labels: ["."],
					series: [1]
				},
				responsiveOptions : [
					['screen and (min-width: 100px)', {
						labelOffset: 67,
						chartPadding: 25,
						labelDirection: 'explode',
					}],
				],
				chartOptions: { showLabel: true}
			},
			pieChartNivel: {
				data: {
					labels: ["."],
					series: [1]
				},
				responsiveOptions : [
					['screen and (min-width: 100px)', {
						labelOffset: 67,
						chartPadding: 25,
						labelDirection: 'explode',
					}],
				],
				chartOptions: { showLabel: true}
			},
			pieChartStaff: {
				data: {
					labels: ["."],
					series: [1]
				},
				responsiveOptions : [
					['screen and (min-width: 100px)', {
						labelOffset: 67,
						chartPadding: 25,
						labelDirection: 'explode',
					}],
				],
				chartOptions: { showLabel: true}
			},
			pieChartCirujano: {
				data: {
					labels: ["."],
					series: [1]
				},
				responsiveOptions : [
					['screen and (min-width: 100px)', {
						labelOffset: 67,
						chartPadding: 25,
						labelDirection: 'explode',
					}],
				],
				chartOptions: { showLabel: true}
			},
			pieChartEspecialidades: {
				data: {
					labels: ["."],
					series: [1]
				},
				responsiveOptions : [
					['screen and (min-width: 100px)', {
						labelOffset: 67,
						chartPadding: 25,
						labelDirection: 'explode',
					}],
				],
				chartOptions: { showLabel: true}
			},
			pieChartObraSocial: {
				data: {
					labels: ["."],
					series: [1]
				},
				responsiveOptions : [
					['screen and (min-width: 100px)', {
						labelOffset: 67,
						chartPadding: 25,
						labelDirection: 'explode',
					}],
				],
				chartOptions: { showLabel: true}
			},
			pieChartSubEspecialidades: {
				data: {
					labels: ["."],
					series: [1]
				},
				responsiveOptions : [
					['screen and (min-width: 100px)', {
						labelOffset: 67,
						chartPadding: 25,
						labelDirection: 'explode',
					}],
				],
				chartOptions: { showLabel: true}
			},
		}
	}, 
	created: function () {
		this.submited = false;
		_this = this;
		_this.getSedes();
		this.getEstadisticasCirugia();
		this.getTotalNivelesCirugia();
		this.getTotalInternacionesPorStaff();
		this.getTotalCirugiasPorEspecialidad();
		this.getTotalProcedimientosPorSubEspecialidad();
		this.getTotalCirugiasPorCirujanos();
		this.getEspecialidades();
		this.getSubEspecialidades();
		this.getTotalCirugiasPorObraSocial();
	}, 
	methods: { 
		getEstadisticasCirugia: function () {
			this.getTotalCirugias();
			this.getTotalInternacionesPorTipo();
			this.getTotalInternacionesAmbulatorias();
			this.getTotalProcedimientosCirugia();
			this.getTotalCirugiasPorVia();
		},
		getTotalCirugias: function () {
			this.buscando = true;
			estadisticaService.getTotalCirugias({fechaDesde: _this.search.fechaDesde, fechaHasta: _this.search.fechaHasta, sede: _this.search.sede, 
												idEspecialidadInternacion: _this.search.idEspecialidadInternacion, idSubEspecialidad: _this.search.idSubEspecialidad}).then(function(response) {
				_this.buscando = false;
				_this.cantidadCirugias = '-';
				if(response.body.length > 0) {
					for (let value of response.body) {
						_this.cantidadCirugias = value.cantidadCirugias;
					} 

					/*_this.cirugiasPorNiveles.forEach(value => {
						value.porcentaje = value.cantidadCirugias  / _this.cantidadCirugias;
						value.porcentaje = (value.porcentaje * 100).toFixed(2) + "%";
					});*/
				} 
			}, function(error) { 
				_this.search.exportTo = ''; this.buscando = false; _this.submited = false; generalService.showRequestErrors(error, _this.$bvModal); return;
			});
		},
		getTotalInternacionesPorTipo: function () {
			this.buscando = true;
			let series = [];
			let labels = [];
			_this.internacionesPorTipo = [];
			let total = 0;
			estadisticaService.getTotalInternacionesPorTipo({fechaDesde: _this.search.fechaDesde, fechaHasta: _this.search.fechaHasta, sede: _this.search.sede, idEspecialidadInternacion: _this.search.idEspecialidadInternacion, idSubEspecialidad: _this.search.idSubEspecialidad}).then(function(response) {
				_this.buscando = false;
				if(response.body.length > 0) {
					for (let value of response.body) {
						_this.internacionesPorTipo.push(value);
						series.push(value.cantidadCirugias);
						total += value.cantidadCirugias;
						labels.push(value.tipoInternacion);
					}
				}
				for(let i = 0; i < labels.length; i++) {
					let porcentaje = series[i] / total;
					let label = labels[i] + ": " + (porcentaje * 100).toFixed(2) + "% (" + series[i] + ")";
					label = label.substring(0, label.indexOf(":"));
					labels[i] = label;
					_this.internacionesPorTipo[i].porcentaje =  (porcentaje * 100).toFixed(2) + "%";
				}
				_this.pieChart.data = {
					labels: labels,
					series: series
				}
			}, function(error) { 
				_this.search.exportTo = '';
				this.buscando = false;
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getTotalInternacionesAmbulatorias: function () {
			this.buscando = true;
			let series = [];
			let labels = [];
			let total = 0;
			_this.cantidadInternaciones = 0;
			_this.internacionesAmbulatorias = [];
			estadisticaService.getTotalInternacionesAmbulatorias({fechaDesde: _this.search.fechaDesde, fechaHasta: _this.search.fechaHasta, sede: _this.search.sede, idEspecialidadInternacion: _this.search.idEspecialidadInternacion, idSubEspecialidad: _this.search.idSubEspecialidad}).then(function(response) {
				_this.buscando = false;
				if(response.body.length > 0) {
					for (let value of response.body) {
						_this.internacionesAmbulatorias.push(value);
						series.push(value.cantidadCirugias);
						total += value.cantidadCirugias;
						labels.push(value.ambulatorio);
						if(value.ambulatorio == 'SI') {
							_this.cantidadInternacionesAmbulatorias = value.cantidadCirugias;
						}
					}
				}
				for(let i = 0; i < labels.length; i++) {
					let porcentaje = series[i] / total;
					let label = labels[i] + ": " + porcentaje.toFixed(2) * 100 + "% (" + series[i] + ")";
					label = label.substring(0, label.indexOf(":"));
					labels[i] = label;
					//_this.cantidadInternacionesAmbulatorias[i].porcentaje = porcentaje.toFixed(2) * 100 + "%";;
				}
				_this.cantidadInternaciones = total;
				_this.ambulatorioPieChart = {
					data: {
						labels: labels,
						series: series
					},
				}
			}, function(error) { 
				_this.search.exportTo = '';
				this.buscando = false;
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getTotalNivelesCirugia: function () {
			this.buscando = true;
			_this.cirugiasPorNiveles = [];
			estadisticaService.getTotalNivelesCirugia({fechaDesde: _this.search.fechaNivelDesde, fechaHasta: _this.search.fechaNivelHasta, sede: _this.search.sedeNivel, 
				idEspecialidadInternacion: _this.search.idEspecialidadInternacionNivel, idSubEspecialidad: _this.search.idSubEspecialidadNivel}).then(function(response) {
				_this.buscando = false;
				let cantidadCirugias = "-"
				if(response.body.length > 0) {
					for (let value of response.body) {
						estadisticaService.getTotalCirugias({fechaDesde: _this.search.fechaNivelDesde, fechaHasta: _this.search.fechaNivelHasta, sede: _this.search.sedeNivel, 
							idEspecialidadInternacion: _this.search.idEspecialidadInternacionNivel, idSubEspecialidad: _this.search.idSubEspecialidadNivel}).then(function(response) {
							_this.buscando = false;
							if(response.body.length > 0) {
								for (let valueC of response.body) {
									cantidadCirugias = valueC.cantidadCirugias > 0 ? valueC.cantidadCirugias : 0;
									value.porcentaje = cantidadCirugias > 0 ? value.cantidadCirugias  / cantidadCirugias : 0;
									value.porcentaje = (value.porcentaje * 100).toFixed(2) + "%";
									_this.cirugiasPorNiveles.push(value);
								} 
								_this.actualizaGrafico(_this.pieChartNivel, _this.cirugiasPorNiveles, "cantidadCirugias", "nivelCirugia", cantidadCirugias);
							} 
						}, function(error) { 
							_this.search.exportTo = ''; this.buscando = false; _this.submited = false; generalService.showRequestErrors(error, _this.$bvModal); return;
						});
					}
				}
			}, function(error) { 
				_this.search.exportTo = '';
				this.buscando = false;
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getTotalProcedimientosCirugia: function () {
			this.buscando = true;
			_this.totalProcedimientos = 0; 
			estadisticaService.getTotalProcedimientosCirugia({fechaDesde: _this.search.fechaDesde, fechaHasta: _this.search.fechaHasta, sede: _this.search.sede, 
				idEspecialidadInternacion: _this.search.idEspecialidadInternacion, idSubEspecialidad: _this.search.idSubEspecialidad}).then(function(response) {
				_this.buscando = false;
				if(response.body.length > 0) {
					for (let value of response.body) {
						_this.totalProcedimientos = value.cantidadProcedimientos;
					}
				}
			}, function(error) { 
				_this.search.exportTo = '';
				this.buscando = false;
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		}, 
		getTotalInternacionesPorStaff: function () {
			this.buscando = true;
			estadisticaService.getTotalInternacionesPorStaff({fechaDesde: _this.search.fechaStaffDesde, fechaHasta: _this.search.fechaStaffHasta, sede: _this.search.sedeStaff, idEspecialidadInternacion: _this.search.idEspecialidadInternacionStaff}).then(function(response) {
				_this.buscando = false;
				let total = 0;
				_this.internacionesPorStaff = [];
				if(response.body.length > 0) {
					for (let value of response.body) {
						let internacionPorStaff = {
							cantidadInternaciones: value.cantidadInternaciones,
							idStaffInternacion: value.idStaffInternacion,
							apellidoProfesional: value.apellidoProfesional,
							nombreProfesional: value.nombreProfesional,							
							label: value.nombreProfesional + " " + value.apellidoProfesional
						}
						total += internacionPorStaff.cantidadInternaciones;
						_this.internacionesPorStaff.push(internacionPorStaff);
					}
					for (let value of _this.internacionesPorStaff) {
						let porcentaje = value.cantidadInternaciones / total;
						value.porcentaje = (porcentaje * 100).toFixed(2) + "%";
					}
				}
				_this.actualizaGrafico(_this.pieChartStaff, _this.internacionesPorStaff, "cantidadInternaciones", "label", 0);
			}, function(error) { 
				_this.search.exportTo = '';
				this.buscando = false;
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getTotalCirugiasPorEspecialidad: function () {
			this.buscando = true;
			_this.internacionesPorEspecialidad = [];
			estadisticaService.getTotalCirugiasPorEspecialidad({fechaDesde: _this.search.fechaEspecialidadDesde, fechaHasta: _this.search.fechaEspecialidadHasta, sede: _this.search.sedeEspecialidad, idEspecialidadInternacion: _this.search.idEspecialidadInternacionEspecialidad}).then(function(response) {
				_this.buscando = false;
				let total = 0;
				if(response.body.length > 0) {
					for (let value of response.body) {
						let internacionPorEspecialidad = {
							cantidadInternaciones: value.cantidadInternaciones,
							idEspecialidad: value.idEspecialidad,
							descripcionEspecialidad: value.descripcionEspecialidad,
						}
						total += internacionPorEspecialidad.cantidadInternaciones;
						_this.internacionesPorEspecialidad.push(internacionPorEspecialidad);
					}
					for (let value of _this.internacionesPorEspecialidad) {
						let porcentaje = value.cantidadInternaciones / total;
						value.porcentaje = (porcentaje * 100).toFixed(2) + "%";
					}
				}
				_this.pieChartEspecialidades.chartOptions.showLabel = false;
				_this.actualizaGrafico(_this.pieChartEspecialidades, _this.internacionesPorEspecialidad, "cantidadInternaciones", "descripcionEspecialidad", 0);
			}, function(error) { 
				_this.search.exportTo = '';
				this.buscando = false;
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getTotalProcedimientosPorSubEspecialidad: function () {
			this.buscando = true;
			_this.cirugiasPorSubEspecialidad = [];
			estadisticaService.getTotalProcedimientosPorSubEspecialidad({fechaDesde: _this.search.fechaSubEspecialidadDesde, fechaHasta: _this.search.fechaSubEspecialidadHasta, sede: _this.search.sedeSubEspecialidad, idEspecialidadInternacion: _this.search.idEspecialidadInternacionSubEspecialidad}).then(function(response) {
				_this.buscando = false;
				let total = 0;
				if(response.body.length > 0) {
					for (let value of response.body) {
						let cirugiasPorSubEspecialidad = {
							cantidadCirgias: value.cantidadCirgias,
							idSubEspecialidad: value.idSubEspecialidad,
							descripcionSubEspecialidad: value.descripcionSubEspecialidad,
						}
						total += cirugiasPorSubEspecialidad.cantidadCirgias;
						_this.cirugiasPorSubEspecialidad.push(cirugiasPorSubEspecialidad);
					}
					for (let value of _this.cirugiasPorSubEspecialidad) {
						let porcentaje = value.cantidadCirgias / total;
						value.porcentaje = (porcentaje * 100).toFixed(2) + "%";
					}
				}
				_this.pieChartSubEspecialidades.chartOptions.showLabel = false;
				_this.actualizaGrafico(_this.pieChartSubEspecialidades, _this.cirugiasPorSubEspecialidad, "cantidadCirgias", "descripcionSubEspecialidad", 0);
			}, function(error) { 
				_this.search.exportTo = '';
				this.buscando = false;
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getTotalCirugiasPorObraSocial: function () {
			this.buscando = true;
			_this.cirugiasPorObraSocial = [];
			estadisticaService.getTotalCirugiasPorObraSocial({fechaDesde: _this.search.fechaObraSDesde, fechaHasta: _this.search.fechaObraSHasta, sede: _this.search.sedeObraS, idEspecialidad: _this.search.idEspecialidadObraS, idSubEspecialidad: _this.search.idSubEspecialidadObraS}).then(function(response) {
				_this.buscando = false;
				let total = 0;
				if(response.body.length > 0) {
					for (let value of response.body) {
						let cirugiasPorObraSocial = {
							cantidadCirugias: value.cantidadCirugias,
							idObraSocial: value.idObraSocial,
							descripcionObraSocial: value.nombreObraSocial,
						}
						total += cirugiasPorObraSocial.cantidadCirugias;
						_this.cirugiasPorObraSocial.push(cirugiasPorObraSocial);
					}
					for (let value of _this.cirugiasPorObraSocial) {
						let porcentaje = value.cantidadCirugias / total;
						value.porcentaje = (porcentaje * 100).toFixed(2) + "%";
					}
				} console.log(_this.cirugiasPorObraSocial)
				_this.pieChartObraSocial.chartOptions.showLabel = false;
				_this.actualizaGrafico(_this.pieChartObraSocial, _this.cirugiasPorObraSocial, "cantidadCirugias", "nombreObraSocial", 0);
			}, function(error) { 
				_this.search.exportTo = '';
				this.buscando = false;
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getTotalCirugiasPorVia: function () {
			this.buscando = true;
			_this.cirugiasPorVia = [];
			estadisticaService.getTotalCirugiasPorVia({fechaDesde: _this.search.fechaDesde, fechaHasta: _this.search.fechaHasta, sede: _this.search.sede, 
				idEspecialidadInternacion: _this.search.idEspecialidadInternacion, idSubEspecialidad: _this.search.idSubEspecialidad}).then(function(response) {
				_this.buscando = false;
				let total = 0;
				if(response.body.length > 0) {
					for (let value of response.body) {
						let cirugiaPorVia = {
							cantidadCirugias: value.cantidadCirugias,
							idVia: value.idVia,
							descripcionVia: value.descripcionVia,
						}
						total += cirugiaPorVia.cantidadCirugias;
						_this.cirugiasPorVia.push(cirugiaPorVia);
					}
					for (let value of _this.cirugiasPorVia) {
						let porcentaje = value.cantidadCirugias / total;
						value.porcentaje = (porcentaje.toFixed(2) * 100).toFixed(2) + "%";
					}
				}
			}, function(error) { 
				_this.search.exportTo = '';
				this.buscando = false;
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getEspecialidades: function() {
			if(_this.especialidades.length != 1)
				_this.especialidades = [];
			datosParametricosService.getEspecialidades({activoDatoParametrico: 1}).then(function(response) {					
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						if(value.activoDatoParametrico == 1) {
							_this.especialidades.push(value);
						}
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getSubEspecialidades: function() {
			_this.subespecialidades = [];
			datosParametricosService.getSubEspecialidades({activoDatoParametrico: 1}).then(function(response) {					
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						if(value.activoDatoParametrico == 1) {
							_this.subespecialidades.push(value);
						}
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getTotalCirugiasPorCirujanos: function () {
			this.buscando = true;
			_this.cirugiasPorCirujano = [];
			estadisticaService.getTotalCirugiasPorCirujanos({fechaDesde: _this.search.fechaCirujanoDesde, fechaHasta: _this.search.fechaCirujanoHasta, sede: _this.sedeCirujano, 
															idEspecialidadInternacion: _this.search.idEspecialidadInternacionCirujano, idSubEspecialidad: _this.search.idSubEspecialidadCirujano}).then(function(response) {
				_this.buscando = false;
				let total = 0;
				if(response.body.length > 0) {
					for (let value of response.body) {
						let data = {
							cantidadCirugias: value.cantidadCirugias,
							idCirujano: value.idCirujano,
							apellidoProfesional: value.apellidoProfesional,
							nombreProfesional: value.nombreProfesional,							
							label: value.nombreProfesional + " " + value.apellidoProfesional
						}
						total += data.cantidadCirugias;
						_this.cirugiasPorCirujano.push(data);
					}
					for (let valueC of _this.cirugiasPorCirujano) {
						let porcentaje = valueC.cantidadCirugias / total;
						valueC.porcentaje = (porcentaje * 100).toFixed(2) + "%";
					}
				}
				_this.actualizaGrafico(_this.pieChartCirujano, _this.cirugiasPorCirujano, "cantidadCirugias", "label", 0);
			}, function(error) { 
				_this.search.exportTo = '';
				this.buscando = false;
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		cambiarGrafico(e) {	
			let selectValue = parseInt(e.target.value);
			switch (selectValue) {
				case 1:
					_this.actualizaGrafico(_this.pieChart, _this.internacionesPorTipo, "cantidadCirugias", "tipoInternacion", 0);
					break;
				case 2:
					_this.actualizaGrafico(_this.pieChart, _this.internacionesAmbulatorias, "cantidadCirugias", "ambulatorio", 0);
					break;
				case 3:
					_this.actualizaGrafico(_this.pieChartNivel, _this.cirugiasPorNiveles, "cantidadCirugias", "nivelCirugia", _this.cantidadCirugias);
					break;
				case 4:
					_this.actualizaGrafico(_this.pieChartStaff, _this.internacionesPorStaff, "cantidadInternaciones", "label", 0);
					break;
				case 5:
					_this.actualizaGrafico(_this.pieChartEspecialidades, _this.internacionesPorEspecialidad, "cantidadInternaciones", "descripcionEspecialidad", 0);
					break;
				case 6:
					_this.actualizaGrafico(_this.pieChart, _this.cirugiasPorVia, "cantidadCirugias", "descripcionVia", 0);
					break;
				case 7:
					_this.actualizaGrafico(_this.pieChartCirujano, _this.cirugiasPorCirujano, "cantidadCirugias", "label", 0);
					break;
				case 8:
					_this.actualizaGrafico(_this.pieChartSubEspecialidades, _this.cirugiasPorSubEspecialidad, "cantidadCirugias", "label", 0);
					break;
				case 9:
					_this.actualizaGrafico(_this.pieChartObraSocial, _this.cirugiasPorObraSocial, "cantidadCirugias", "label", 0);
					break;
				default:
					break;
			}
		},
		actualizaGrafico(pieChart, data, cantidad, labelName, totalCustom) {
			let labels = [];
			let series = [];
			let total = 0;
			for(let i = 0; i < data.length; i++) {
				let value = data[i];
				if(value[cantidad] != 0) {
					series.push(value[cantidad]);
					total += value[cantidad];
					labels.push(value[labelName]);
				}
			}
			for(let j = 0; j < series.length; j++) {
				if(totalCustom > 0) {
					total = totalCustom;
				}
				let porcentaje = series[j] / total;
				let label = labels[j] + ": " + (porcentaje.toFixed(2) * 100).toFixed(2) + "% (" + series[j] + ")";
				labels[j] = label.substring(0, label.indexOf(":"));
				//_this.data[j].porcentaje =  porcentaje.toFixed(2) * 100 + "%";
			}
			pieChart.data = {
				labels: labels,
				series: series
			}
		},
		getSedes: function() {
			_this.sedes = [{idSede:"", nombreSede:"Sede"}];
			sedeService.get({}).then(function(response) {					
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						//if(value.activoObraSocial == 1) {
							_this.sedes.push(value);
						//}
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		limpiar() {
			this.search = JSON.parse(search);
			this.getEstadisticasCirugia();
			this.getTotalNivelesCirugia();
			this.getTotalInternacionesPorStaff();
			this.getTotalCirugiasPorEspecialidad();
			this.getTotalCirugiasPorCirujanos();
		},
		limpiarNivel() {
			this.search = JSON.parse(search);
			this.getTotalNivelesCirugia();
		},
		limpiarStaff() {
			this.search = JSON.parse(search);
			this.getTotalInternacionesPorStaff();
		},
		limpiarCirujanos() {
			this.search = JSON.parse(search);
			this.getTotalCirugiasPorCirujanos();
		},
		limpiarEspecialidad() {
			this.search = JSON.parse(search);
			this.getTotalIgetTotalCirugiasPorEspecialidadnternacionesPorEspecialidad();
		}
	}
}

